<div  class="rek-c-headered-page kt-portlet">
  <div class="rek-c-headered-page__head kt-portlet__head"
    [class.rek-c-headered-page__head--large-margin]="headeredPageType === HeaderedPageType.LARGE_PADDING">
    <div class="kt-portlet__head-label">
      <h3 class="rek-c-headered-page__head-title kt-portlet__head-title">
        {{ header }}
      </h3>
    </div>
  </div>

  <div class="rek-c-headered-page__body kt-portlet__body"
    [class.rek-c-headered-page__body--large-padding]="headeredPageType === HeaderedPageType.LARGE_PADDING">
    <ng-content></ng-content>
  </div>
</div>